export class EsgConstants {
	public static readonly INDUSTRY_INVOLVEMENT_METRICS = ['CONTROVERSIAL_WEAPONS', 'NUCLEAR_WEAPONS', 'CIVILIAN_FIREARMS', 'TOBACCO', 'THERMAL_COAL'];

	public static readonly ESG_METRIC_ICONS = {
		FORESTS_CUT_PER_YEAR: 'BLK_icon_tree.svg',
		PASSENGER_VEHICLES_DRIVEN: 'BLK_icon_car.svg',
		HOMES_ENERGY_PER_YEAR: 'BLK_icon_house.svg',
		POUNDS_COAL_BURNED: 'BLK_icon_coal.svg',
		CONTROVERSIAL_WEAPONS: 'BLK_icon_weapon.svg',
		NUCLEAR_WEAPONS: 'BLK_icon_radiation.svg',
		CIVILIAN_FIREARMS: 'BLK_icon_warning.svg',
		TOBACCO: 'BLK_icon_tobacco.svg',
		THERMAL_COAL: 'BLK_icon_coal.svg',
		REFRIGERATOR: 'esg_icon_refrigerator.svg',
		CAR_TRANSPORTATION: 'esg_icon_vehicle.svg',
		LCD_TV: 'esg_icon_TV.svg',
		DISHWASHER: 'esg_icon_food.svg',
		WATER_HEATING: 'esg_icon_water.svg',
		CARBON_EMISSION_DIFFERENCE: 'BLK_icon_percent.svg',
		PETROL_CONSUMED: 'BLK_icon_car.svg'
	};

	public static readonly SHOW_AS_OF_DATE_DYNAMIC_DEFAULT = false;
}
